import { render } from "./business-icon.svg?vue&type=template&id=6c01e3ca"
import script from "./business-icon.svg?vue&type=script&lang=js"
export * from "./business-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2836/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__